import { jsx as _jsx, jsxs as _jsxs } from "react/jsx-runtime";
import { ErrorMessage } from '@as-react/common-types';
import { useTranslation } from 'react-i18next';
import { I18N_NAMESPACES } from '../../../constants/i18nConstants';
import { Box, ButtonAlpha, Stack, TextAlpha } from '@yonderland/andes-react';
export const CheckoutConfirmationErrorPage = ({ retry }) => {
    const { t } = useTranslation([I18N_NAMESPACES.buy, I18N_NAMESPACES.general]);
    return (_jsx(Box, { paddingBlockStart: { base: '16', md: '32' }, paddingBlockEnd: { base: '20', md: '32' }, children: _jsxs(Stack, { gap: "4", direction: "col", align: "center", children: [_jsx(TextAlpha, { variant: "bodyL", children: t(ErrorMessage.API_ERROR) }), _jsx(ButtonAlpha, { onClick: retry, text: t('buy.error.retry') })] }) }));
};
